var Model = require("../types/Model.js");

var STATE_SEND_WAIT = 5 * 1000; // 5 seconds

module.exports = Model({
	name: "power",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_stateTimer: null,
});

function init() {
	this.push({
		localization: {}
	});

	this._stateTimer = setTimeout(send_sleep_state.bind(this), STATE_SEND_WAIT);
	this.emit("orientationlocker:trigger:lock", {
		orientation: "landscape"
	});
}

function uninit() {
	clearTimeout(this._stateTimer);
}

function send_sleep_state() {
	this.emit("machinetracker:trigger:state", {
		state: "power"
	});
}

function listeners() {
	return {
		"localization:updated": handle_localization_update,
		"screensaver:updated": handle_screensaver_update
	};
}

function triggers() {
	return {
		"wake": handle_trigger_wake
	};
}

function handle_trigger_wake() {
	this.emit("app:trigger:wake");
	this.emit("usermetrics:trigger:track", "wake atouchaway from sleep");
}

function handle_localization_update(data) {
	this.extend({
		localization: data.localization
	});
}

function handle_screensaver_update(data){
	this.extend({
		screensaver: data
	});
}
